export const UPDATE_FAQ_DATA ='BUSHOME/UPDATE_FAQ_DATA';
export const UPDATE_META_DATA = 'BUSHOME/UPDATE_META_DATA';
export const UPDATE_GOSAFE_BANNER ='BUSHOME/UPDATE_GOSAFE_BANNER';
export const UPDATE_OFFERS_DATA = 'BUSHOME/UPDATE_OFFERS_DATA';
export const UPDATE_RTC_HOME_BANNER ='BUSHOME/UPDATE_RTC_HOME_BANNER';
export const UPDATE_BUS_HOME_CAROUSEL = "UPDATE_BUS_HOME_CAROUSEL";
export const SAVE_LOYALTY_DATA = "SAVE_LOYALTY_DATA";
